"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapPromiseInTimeout = void 0;
const errors_1 = require("@deliverr/errors");
async function wrapPromiseInTimeout(orgPromise, timeoutInMs, timeoutError) {
    if (!timeoutError) {
        timeoutError = new errors_1.DeliverrError("Call timed out");
    }
    const timeoutPromise = new Promise((_resolve, reject) => setTimeout(() => {
        reject(timeoutError);
    }, timeoutInMs));
    return Promise.race([orgPromise, timeoutPromise]).catch((err) => {
        throw err;
    });
}
exports.wrapPromiseInTimeout = wrapPromiseInTimeout;
//# sourceMappingURL=PromiseUtils.js.map